import { observer } from 'mobx-react';
import { useEffect, useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { localeStore } from '~/mobx/localesStore';
import Pagination from '~/view/components/Controls/Pagination';
import Preloader from '~/view/components/Controls/Preloader';
import GridTable from '~/view/containers/GridTable';
import { promocodeLogStore } from '~/view/screens/PromocodeLogScreen/store/promocodeLogStore';
import { emptyArray } from '~/utils/helpers';
import PromocodeLogListRow from '~/view/screens/PromocodeLogScreen/components/PromocodeLogList/PromocodeLogListRow';
import './style.scss';

const LoaderSkeleton = () => {
  return (
    <div className="promocode-log-list-row mr-4">
      <Skeleton height={30} />
    </div>
  );
};

const NotFoundPlaceholder = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center mt-6">
      <p className="family-medium text-size-24 color-gray2">{localeStore.t('no_results_found')}</p>
    </div>
  );
};

const PromocodeLogList = observer(() => {
  useEffect(() => {
    promocodeLogStore.fetchPromocodeLogList();
  }, []);

  const columnTitles = useMemo(
    () => [
      { title: localeStore.t('promocodelog_order_created_column') },
      { title: localeStore.t('promocodelog_promocode_name_column') },
      { title: localeStore.t('promocodelog_promocode_id_column') },
      { title: localeStore.t('promocodelog_generated_discount_column') },
      { title: localeStore.t('promocodelog_order_id_column') },
      { title: localeStore.t('promocodelog_promocode_value_column') },
      { title: localeStore.t('promocodelog_customer_phone_column') },
    ],
    []
  );

  if (promocodeLogStore.isDataNotPresented) {
    return <NotFoundPlaceholder />;
  }

  return (
    <div className="d-flex flex-column flex-grow-1 pt-1">
      <GridTable
        gridTemplateClass="promocode-log-list-row__grid-template pr-4"
        bodyClassName="promocode-log-row__body scrollable-block__scroll_small"
        scrollClassName="orders-rating-scroll"
        columnTitles={columnTitles}
      >
        {promocodeLogStore.loading
          ? emptyArray().map((_, index) => <LoaderSkeleton key={index} />)
          : promocodeLogStore.promocodeLogList.map((promocodeLog) => <PromocodeLogListRow key={promocodeLog.id} data={promocodeLog} />)}
      </GridTable>

      <Pagination
        visible={promocodeLogStore.promocodeLogList.length > 0}
        className="mt-2"
        pagination={promocodeLogStore.pagination}
        onChange={promocodeLogStore.fetchPromocodeLogList}
        showPaginationInfo
      />
      <Preloader visible={promocodeLogStore.loading} />
    </div>
  );
});

export default PromocodeLogList;
